import { __assign } from "tslib";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock, Fragment as _Fragment } from "vue";
var _hoisted_1 = ["xlink:href"];
import { computed, useAttrs } from "vue";
import { Icon } from "@iconify/vue";
export default /*@__PURE__*/ _defineComponent(__assign({ name: "SvgIcon", inheritAttrs: false }, { __name: 'svg-icon', props: {
        icon: {},
        localIcon: {}
    }, setup: function (__props) {
        /**
         * Props
         *
         * - Support iconify and local svg icon
         * - If icon and localIcon are passed at the same time, localIcon will be rendered first
         */
        var props = __props;
        var attrs = useAttrs();
        var bindAttrs = computed(function () { return ({
            class: attrs.class || "",
            style: attrs.style || "",
        }); });
        var symbolId = computed(function () {
            // const { VITE_ICON_LOCAL_PREFIX: prefix } = import.meta.env;
            var prefix = "local-icon";
            var defaultLocalIcon = "no-icon";
            var icon = props.localIcon || defaultLocalIcon;
            return "#".concat(prefix, "-").concat(icon);
        });
        /** If localIcon is passed, render localIcon first */
        var renderLocalIcon = computed(function () { return props.localIcon || !props.icon; });
        return function (_ctx, _cache) {
            return (renderLocalIcon.value)
                ? (_openBlock(), _createElementBlock("svg", _mergeProps({
                    key: 0,
                    "aria-hidden": "true",
                    width: "2em",
                    height: "2em"
                }, bindAttrs.value), [
                    _createElementVNode("use", {
                        "xlink:href": symbolId.value,
                        fill: "currentColor"
                    }, null, 8, _hoisted_1)
                ], 16))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    (_ctx.icon)
                        ? (_openBlock(), _createBlock(_unref(Icon), _mergeProps({
                            key: 0,
                            icon: _ctx.icon
                        }, bindAttrs.value, {
                            width: "1.5rem",
                            height: "1.5rem"
                        }), null, 16, ["icon"]))
                        : _createCommentVNode("", true)
                ], 64));
        };
    } }));
